import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BranchNameComponent } from './branch-name/branch-name.component';
import { FileTransferComponent } from './file-transfer/file-transfer.component';
import { EMRService } from '../EMR.service';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { AuthService } from 'app/auth/auth.service';
import { DynamicHelpListComponent } from '../Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { IPDsurgicalRecordModel } from 'app/ipd/models/surgicalRecordModel';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DocFileModel, procedureModal } from './model/Proceture.model';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { WebSocketService } from '../webSocket.Service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { imageworkupService } from '../Image_workup/Services/Imageworkup.services';
@Component({
  selector: 'app-Procedure',
  templateUrl: './Procedure.component.html',
  styleUrls: ['./Procedure.component.scss']
})
export class ProcedureComponent implements OnInit {
  destroyprocedure$: Subject<boolean> = new Subject<boolean>();
  @Input() triggerApiCall: boolean = false;
  procedureData: any;
  filteredProcedureArray: Observable<any[]>
  procedureControl: FormControl;
  doctorControl: FormControl;
  filteredDoctorArray: Observable<any[]>;
  billdetailData: any;
  sourceData: any = [];
  filteredSourceArray: Observable<any[]>
  sourceControl: FormControl;
  private invData: any = []
  selectedProcedureId: any;
  procData: any;
  private surgicalRecordobj: IPDsurgicalRecordModel = {};
  private emrDoctorCtrl: FormControl;
  newdrworkupid: any;
  invdetailData: any = [];
  private dataSource: DocFileModel[] = [];
  showTable: boolean = false;
  inputLength: number = 0;
  advisedDoctorControl: FormControl;
  filteredAdvisedDoctorArray: Observable<any[]>;
  procdatabyTranId: any;
  selectedProcedure: procedureModal = new procedureModal();
  showspinner: boolean = false;
  selectedIndex: number = 0;
  selectedBill: any;
  isDateDisabled: boolean = true;
  private selectedpfile: any = [];
  procNameInvalid = false;
  sourceInvalid = false;
  advisedByInvalid = false;


  private doctorlist: any = [];
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChild('procNameInput', { static: false }) procNameInput: ElementRef;
  @ViewChild('sourceInput', { static: false }) sourceInput: ElementRef;
  @ViewChild('advisedByInput', { static: false }) advisedByInput: ElementRef;

  constructor(public dialog: MatDialog, private emrService: EMRService, private opdvisitService: OpdVisitService,
    private authservice: AuthService, private dashboardService: DashboardService, private webSocketService: WebSocketService
    , private sanitizer: DomSanitizer, private imageWorkupService: imageworkupService) { }

  ngOnInit() {
    this.doctorlist = [];
    this.selectedProcedure = {};
    this.selectedpfile = [];
    this.dataSource = [];
    this.procedureControl = new FormControl();
    this.doctorControl = new FormControl();
    this.advisedDoctorControl = new FormControl();
    this.emrDoctorCtrl = new FormControl();
    this.sourceControl = new FormControl();
    this.selectedProcedure.ProcedureDate = new Date().toISOString().slice(0, 10)
    this.getregisterMaster()
    this.getbillDetail(this.opdvisitService.patientdetails.pkRegId);
    this.getprocedureDetail(this.opdvisitService.patientdetails.pkRegId);
    // if (this.authservice.Loggeduser.usertypeid == 6) {
    //   this.newdrworkupid = this.authservice.Loggeduser.userid;
    // } else {
    //   this.newdrworkupid = this.opdvisitService.DoctorIdEmr;
    // }
    // this.getinvDetailbyvisitId(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid)
    if (this.triggerApiCall) {
      this.getinvDetailbyvisitId(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid);
    }


    //     this.emrService.pexshare.subscribe((x: any) => {
    //       if (x === 'section26') {
    //         this.getinvDetailbyvisitId(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid);
    //       }
    // });

    this.selectedProcedure.performTime = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
    this.doctorlist = this.authservice.users.filter(item => item.fkUserTypeId == 6 || item.fkUserTypeId == 5);
  }

  scrollLeft(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: -200, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: 200, behavior: 'smooth' });
  }
  /** Procedure Download Modal */
  FileTransferModal() {
    var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
    if (mainimagepath.length > 0) {
      if (mainimagepath[0]?.propertyValue) {
        if (this.selectedProcedure.pK_TransactionId > 0) {
          const passarray = this.dataSource;
          const dialogRef = this.dialog.open(FileTransferComponent, {
            panelClass: "full-width-dialog",
            maxWidth: "100vw !important",
            height: "580px",
            width: "840px",
            disableClose: true,
            data: {
              filepath: mainimagepath[0]?.propertyValue,
              pid: this.selectedProcedure.pK_TransactionId,
              bid: this.authservice.Loggeduser.branchid, getdata: passarray
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result?.success && Array.isArray(result.data)) {
              this.dataSource = result.data;
            } else {
              this.dataSource = [];
            }
          });
        } else {
          this.dashboardService.openSnackBar('Please select procedure first', 'OK');
        }
      } else {
        this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
      }
    } else {
      this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
    }

  }
  /** Procedure Download Modal */
  BranchNameModal() {
    const dialogRef = this.dialog.open(BranchNameComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "500px",
      width: "840px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

    });

  }

  ngOnChanges() {
    if (this.triggerApiCall) {
      this.getinvDetailbyvisitId(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid);
    }
  }

  getregisterMaster() {
    this.emrService.GetRegisterMasterByRegisterType().pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      this.procedureData = data
      this.initializeprocedureControl()
      this.initializeDoctorControl();
      this.initializeAdvisedDoctorControl();
    });
  }
  initializeprocedureControl() {
    this.procedureControl = new FormControl();
    this.filteredProcedureArray = this.procedureControl.valueChanges.pipe(
      startWith(""),
      map((procedure) =>
        procedure
          ? this.filterProcedureFunction(procedure)
          : this.procedureData.slice(),
      )
    );
  }

  filterProcedureFunction(name: string): any[] {
    return this.procedureData.filter((procedure) =>
      procedure.registerName.toLowerCase().includes(name.toLowerCase())
    );
  }
  removedata(event: any) {

    if (!event.target.value) {
      this.selectedProcedure.procedureId = null;
      this.selectedProcedureId = null;
      this.selectedProcedure.fK_RegisterSourceDetailId = null;
      this.sourceData = [];
      this.initializesourceControl();
    }
  }
  onProcedureSelected(event, procedure) {

    if (event.isUserInput) {
      this.procNameInvalid = false;
      this.selectedProcedureId = procedure.pK_RegisterId;
      this.selectedProcedure.procedureId = procedure.pK_RegisterId
      this.selectedProcedure.procName = procedure.registerName
      this.getsourcedetail(this.authservice.Loggeduser.branchid, this.selectedProcedureId);
    }
    // const selectedsource = this.procedureData.find(source => source.registerName == event.source.value);
    // if (selectedsource) {
    //   this.selectedProcedure.procName = selectedsource.registerName
    //   this.selectedProcedure.procedureId = selectedsource.pK_RegisterId
    // }
    console.log(this.selectedProcedure.procName)
    console.log(this.selectedProcedure.procedureId)
  }
  isArray(value: any): boolean {
    return this.dataSource.length > 0 ? Array.isArray(value) : false;
  }
  getbillDetail(regId) {
    this.emrService.GetBillDetailByRegID(regId).pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      this.billdetailData = data;
    });
  }

  updateLength(value: string) {
    this.inputLength = value.length;
  }
  getsourcedetail(branchid, regid) {
    this.emrService.GetRegisterSourceDetailByBranchIdByFkRegisterId(branchid, regid).pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      this.sourceData = data;
      this.initializesourceControl()
      if (this.sourceData.length > 0) {
        this.selectFirstOption();
        this.sourceInvalid = false
      }

    });
  }
  selectFirstOption() {
    const firstElement = this.sourceData[0];
    if (firstElement) {
      this.selectedProcedure.FK_RegisterSourceDetailId = firstElement.fK_RegisterId;
      this.sourceControl.setValue(firstElement.source);
      this.onsourceSelected({ option: { value: firstElement.source } }, firstElement);
    }
  }
  initializesourceControl() {
    this.sourceControl = new FormControl();
    this.filteredSourceArray = this.sourceControl.valueChanges.pipe(
      startWith(""),
      map((source) =>
        source
          ? this.filtersourceFunction(source)
          : this.sourceData.slice(),
      )
    );
  }
  filtersourceFunction(name: string): any[] {
    return this.sourceData.filter((source) =>
      source.source.toLowerCase().includes(name.toLowerCase())
    );
  }

  getinvDetail(regid, isProcedure) {
    this.emrService.GetRegisterFieldDetailByFkRegisterId(regid).pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      if (data.length > 0) {
        this.invData = []
        this.invData = data.map(item => ({
          // fieldName: !isProcedure ? "Investigation - " + item.fieldName : item.fieldName,
          fieldName: item.fieldName,
          defaultValues: item.defaultValue,
          defaultValues1: item.defaultValue1,
          fK_FieldId: item.fK_FieldId,
          pK_TranId: item.pK_TranId,
          fK_TransactionId: item.fK_TransactionId
        }));
      } else {
        this.dashboardService.openSnackBar('No Record Found', 'OK');
      }
    });
  }
  loadinvFormat() {
    if (this.selectedProcedureId == null || this.selectedProcedureId == undefined || this.selectedProcedureId == '') {
      this.dashboardService.openSnackBar('Please select a procedure name to load', 'OK');
      return
    }
    this.getinvDetail(this.selectedProcedureId, false);
    this.showTable = true;
  }

  getprocedureDetail(regid) {
    this.emrService.inhouseInvestigation(regid).pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      this.procData = data;
      if (data.length > 0) {
        this.getproceduredetailbytranId(data[0].pK_TransactionId, true)
        this.assignProcedureDetails(data[0]);
        this.getsourcedetail(this.authservice.Loggeduser.branchid, data[0].fK_RegisterId)
      }else{
      this.selectedProcedure.IsActive =true;
      }
    });
  }
  assignProcedureDetails(procedure: any) {
    this.selectedProcedure = {
      ProcedureDate: procedure.procedureDate ? procedure.procedureDate : new Date().toISOString().slice(0, 10),
      FK_DoneById: procedure.fK_DoneById,
      DoneBy: procedure.done,
      FK_RegisterSourceDetailId: procedure.fK_RegisterSourceDetailId,
      FK_AdvisedById: procedure.fK_AdvisedById,
      Eye: procedure.eye,
      ImgUploaded: procedure.imgUploaded,
      IsActive: procedure.isActive,
      ConsentTaken: procedure.consentTaken,
      ConsentUploaded: procedure.consentUploaded,
      procName: procedure.procName,
      source: procedure.source,
      procedureId: procedure.fK_RegisterId,
      pK_TransactionId: procedure.pK_TransactionId,
      advisedByUserName: procedure.advisedByUserName,
      comments: procedure.comments
    };
    if (this.selectedProcedure.pK_TransactionId > 0) {
      this.getprocedureFile();
    }

  }
  selectProcedure(procedure: any, index: number) {
    this.selectedProcedure = {
      ProcedureDate: procedure.procedureDate ? procedure.procedureDate : new Date().toISOString().slice(0, 10),
      FK_DoneById: procedure.fK_DoneById,
      DoneBy: procedure.done,
      FK_RegisterSourceDetailId: procedure.fK_RegisterSourceDetailId,
      FK_AdvisedById: procedure.fK_AdvisedById,
      Eye: procedure.eye,
      ImgUploaded: procedure.imgUploaded,
      IsActive: procedure.isActive,
      ConsentTaken: procedure.consentTaken,
      ConsentUploaded: procedure.consentUploaded,
      procName: procedure.procName,
      source: procedure.source,
      procedureId: procedure.fK_RegisterId,
      pK_TransactionId: procedure.pK_TransactionId,
      advisedByUserName: procedure.advisedByUserName,
      comments: procedure.comments,
      performTime: procedure.performTime ? procedure.performTime : moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss")
    };
    this.selectedIndex = index;
    this.getproceduredetailbytranId(procedure.pK_TransactionId, true);
    this.getsourcedetail(this.authservice.Loggeduser.branchid, procedure.fK_RegisterId);
    if (this.selectedProcedure.pK_TransactionId > 0) {
      this.getprocedureFile();
    }

  }

  getproceduredetailbytranId(id, isProcedure) {
    this.emrService.GetProcedureRegisterDetailByFkTransactionId(id).pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      this.invData = data
      this.invData = data.map(item => ({
        // fieldName: isProcedure ? "Procedure - " + item.fieldName : item.fieldName,
        fieldName: item.fieldName,
        result: item.result,
        result1: item.result1,
        fK_FieldId: item.fK_FieldId,
        pK_TranId: item.pK_TranId,
        fK_TransactionId: item.fK_TransactionId
      }));
    });
  }

  getinvDetailbyvisitId(regId, visitId) {
    this.emrService.GetInvestigationDetailByRegIdByVisitId(regId, visitId).pipe(takeUntil(this.destroyprocedure$)).subscribe((data: any) => {
      this.invdetailData = data;
    });
  }


  refIpdTypePOpup(type, type1?: any, checkid?: number) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: type,
      },
    });

    dialogRef
      .afterClosed().subscribe((result) => {
        if (result != 0) {
          if (type == "OTEYE") {
            this.selectedProcedure.Eye = result;
          }
        }
      });
  }

  openDefaultPopup(
    fieldType: string,
    rowIndex: number,
    prop: 'result' | 'result1',
    procedure
  ) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: fieldType,
        param: 'procedure'
      },
    });

    dialogRef.afterClosed().subscribe((selection: any) => {
      if (selection != 0) {
        this.invData[rowIndex][prop] = selection;
      }
    });
  }



  getTitle(uId: number) {
    const uName = this.doctorlist.filter(
      (item) => item.pkUserId == uId
    );
    if (uName.length > 0) {
      return uName[0]?.userName;
    } else {
      return null;
    }
  }

  initializeDoctorControl() {
    this.doctorControl = new FormControl();
    this.filteredDoctorArray = this.doctorControl.valueChanges.pipe(
      startWith(''),
      map((doctorName) =>
        doctorName ? this.filterDoctorFunction(doctorName) : this.doctorlist.slice()
      )
    );
  }

  filterDoctorFunction(name: any): any[] {
    return this.doctorlist.filter((doctor) =>
      doctor.userName.toLowerCase().includes(name.toLowerCase())
    );
  }

  initializeAdvisedDoctorControl() {
    this.advisedDoctorControl = new FormControl();
    this.filteredAdvisedDoctorArray = this.advisedDoctorControl.valueChanges.pipe(
      startWith(''),
      map((value) => value ? this.filterAdvisedDoctor(value) : this.doctorlist.slice())
    );
  }

  filterAdvisedDoctor(name: string): any[] {
    return this.doctorlist.filter(doctor =>
      doctor.userName.toLowerCase().includes(name.toLowerCase())
    );
  }



  saveprocedure(event) {

    this.procNameInvalid = false;
    this.procNameInvalid = false;
    this.sourceInvalid = false;
    this.advisedByInvalid = false;


    if (!this.selectedProcedure.procName) {
      this.procNameInvalid = true;
      setTimeout(() => this.procNameInput.nativeElement.focus(), 100);
      return this.dashboardService.openSnackBar('Please select Procedure Name', 'OK');

    }

    if (this.selectedProcedure.source == null || this.selectedProcedure.source == '' || this.selectedProcedure.source == undefined) {
      this.sourceInvalid = true;
      setTimeout(() => this.sourceInput.nativeElement.focus(), 100);
      return this.dashboardService.openSnackBar('Please select Source', 'OK');
    }

    if (this.selectedProcedure.advisedByUserName == '' || this.selectedProcedure.advisedByUserName == null || this.selectedProcedure.advisedByUserName == undefined) {
      this.advisedByInvalid = true;
      setTimeout(() => this.advisedByInput.nativeElement.focus(), 100);
      return this.dashboardService.openSnackBar('Please select Advised by Name', 'OK');

    }

    if (this.selectedProcedure.procedureId > 0) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      setTimeout(function () {
        button.removeAttribute('disabled');
      }, 5000);
      this.showspinner = true;
      const payload = {
        "ProcedureRegister": {
          "PK_TransactionId": this.selectedProcedure.pK_TransactionId || 0,
          "FK_RegId": this.opdvisitService.patientdetails.pkRegId,
          "FK_RegisterId": this.selectedProcedure.procedureId,
          "FK_RegisterSourceDetailId": this.selectedProcedure.FK_RegisterSourceDetailId,
          "ProcedureDate": this.selectedProcedure.ProcedureDate,
          "PerformTime": this.selectedProcedure.performTime,
          "FK_DoneById": this.authservice.Loggeduser.userid,
          "ImgUploaded": this.selectedProcedure.ImgUploaded || false,
          "Comments": this.selectedProcedure.comments,
          "IsActive": this.selectedProcedure.IsActive || false,
          "ConsentTaken": this.selectedProcedure.ConsentTaken || false,
          "ConsentUploaded": this.selectedProcedure.ConsentUploaded || false,
          "FK_BranchID": this.authservice.Loggeduser.branchid,
          "FK_AdvisedById": this.selectedProcedure.FK_AdvisedById,
          "Eye": this.selectedProcedure.Eye,
          "FK_VisitId": this.opdvisitService.visitid,
          "IsEdit": this.selectedProcedure.pK_TransactionId > 0 ? true : false,
          "IsDelete": false,
        },
        "ProcedureRegisterDetail": this.invData.map((inv, index) => ({
          "IsEdit": inv.pK_TranId > 0 ? true : false,
          "IsDelete": false,
          "FK_FieldId": inv.fK_FieldId,
          "Result": inv.result,
          "Result1": inv.result1,
          "PK_TranId": inv.pK_TranId || 0,
          "FK_TransactionId": inv.fK_TransactionId || 0,
        }))
      };

      this.emrService.addprocedure(payload).subscribe(
        (response: any) => {
          this.showspinner = false;
          if (response.statusCode == 1) {

            this.emrService.savedrWorkupTrackingSatus(
              this.selectedProcedure.pK_TransactionId > 0 ? "Modify Procedure Workup" : "Procedure Workup",
              this.selectedProcedure.pK_TransactionId > 0 ? "true" : "false",
              "PR"
            );
            const message = this.selectedProcedure.pK_TransactionId > 0
              ? 'Record updated successfully'
              : 'Record saved successfully';

            this.dashboardService.openSnackBar(message, 'OK');

            this.getprocedureDetail(this.opdvisitService.patientdetails.pkRegId);
          } else {
            this.dashboardService.openSnackBar('Error', 'OK');
          }
        },
        (err) => {
          this.showspinner = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    } else {
      this.dashboardService.openSnackBar('Please select procedure Name', 'OK');
    }
  }

  trackingdata(data: any) {

    let payload = {
      "PatientDocumentDetail": {
        "ActionType": "VIEW",
        "Pk_TranId": 0,
        "Fk_BranchId": this.authservice.Loggeduser.branchid,
        "Fk_RegId": this.opdvisitService.patientdetails.pkRegId,
        "Fk_CreatedById": this.authservice.Loggeduser.userid,
        "DocumentType": "PROCEDURE",
        "DocumentName": data.documentName,
        "DocumentURL": data.filePath,
        "StorageType": 'imageserver'
      }
    }
    this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((item: any) => {

    })
  }
  //   ngAfterViewChecked(){
  //      return  Array(this.dataSource);
  //  }

  onDoctorSelected(event: any) {

    const selectedDoctor = this.doctorlist.find(doc => doc.userName == event.source.value);
    if (selectedDoctor) {
      this.advisedByInvalid = false
      this.selectedProcedure.FK_AdvisedById = selectedDoctor.pkUserId;
      this.selectedProcedure.advisedByUserName = selectedDoctor.userName;
    }
  }

  onsourceSelected(event, element) {
    this.selectedProcedure.FK_RegisterSourceDetailId = element.fK_RegisterId;
    this.selectedProcedure.source = element.source
    if (element.fK_RegisterId) {
      this.sourceInvalid = false
    }
  }


  clearProcedure() {
    this.selectedProcedure = {
      ProcedureDate: new Date().toISOString().slice(0, 10),
      FK_DoneById: null,
      DoneBy: null,
      FK_RegisterSourceDetailId: null,
      FK_AdvisedById: null,
      Eye: null,
      ImgUploaded: false,
      IsActive: true,
      ConsentTaken: false,
      ConsentUploaded: false,
      procName: null,
      source: null,
      advisedByUserName: null,
      procedureId: null,
      comments: null,
      fK_RegisterSourceDetailId: null
    };
    if (this.sourceControl) {
      this.sourceControl.setValue(null);
    }
    this.invData = []
  }

  openModal(bill) {
    document.getElementById("testModal").style.display = "block";
    this.selectedBill = bill;
  }
  closetestModal() {
    document.getElementById("testModal").style.display = "none";
  }

  markTestAsDone() {
    if (!this.selectedBill) return;
    const payload = {
      DrInvest: [
        {
          PK_TranId: this.selectedBill.pK_TranId,
          FK_ExamId: this.selectedBill.fK_ExamId,
          FK_ServiceId: this.selectedBill.fK_ServiceId,
          Result: "Done",
          Eye: this.selectedBill.eye,
          IsEdit: this.selectedBill.pK_TranId > 0,
          Academic: this.selectedBill.academic,
          discount: this.selectedBill.discount,
          IsDeleted: 0
        }
      ]
    };

    this.emrService.addinv(payload).subscribe(
      (response: any) => {
        if (response.statusCode == 1) {
          this.dashboardService.openSnackBar('Record saved sucessfully', 'OK');
          this.getinvDetailbyvisitId(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid)
          this.closetestModal()
        } else {
          this.dashboardService.openSnackBar('Error', 'OK');
        }
      },
      (error) => {
        console.error("API Error:", error);
        this.dashboardService.openSnackBar('API Failed', 'OK');
      }
    );
  }
  // file transfer from machine
  transferFIle() {
    if (this.selectedProcedure.pK_TransactionId > 0) {
      if (this.selectedProcedure.source) {
        var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
        if (mainimagepath.length > 0) {
          if (mainimagepath[0]?.propertyValue) {
            this.showspinner = true;
            const message = {
              "message": "UPLOADFILE",
              "ACTIONTYPE": "UPLOADAll",
              "DOCUMENTTYPE": "PROCEDUREIMAGES",
              "BranchId": this.authservice.Loggeduser.branchid.toString(),
              "PATIENTID": this.selectedProcedure.pK_TransactionId.toString(),
              "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
              "WEBNETRAMMACHINEPATH": this.selectedProcedure.source.replace(/\\/g, '\\\\')

            };
            this.webSocketService.sendMessage(message);
            this.webSocketService.getMessages().subscribe(
              (message: any) => {
                this.showspinner = false;
                if (message) {
                  this.dashboardService.openSnackBar(message, "OK");
                  this.webSocketService.disconnect();
                  setTimeout(() => {
                    this.getprocedureFile();
                  }, 200);

                }

              }, err => {
                this.showspinner = false;
                this.dashboardService.openSnackBar("Please set server configuration", "OK");
              });
          } else {
            this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
          }
        } else {
          this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
        }
      } else {
        this.dashboardService.openSnackBar('Please set source path', 'OK');
      }
    } else {
      this.dashboardService.openSnackBar('Please select procedure first', 'OK');
    }
  }
  // get machine data 
  getprocedureFile() {

    this.dataSource = [];
    var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
    if (mainimagepath.length > 0) {
      if (mainimagepath[0]?.propertyValue) {
        const msg = {
          "message": "UPLOADFILE",
          "ACTIONTYPE": "VIEW",
          "DOCUMENTTYPE": 'PROCEDUREIMAGES',
          "BranchId": this.authservice.Loggeduser.branchid.toString(),
          "PATIENTID": this.selectedProcedure.pK_TransactionId.toString(),
          "MAINIMAGEPATH": mainimagepath[0]?.propertyValue
        }
        this.webSocketService.sendMessage(msg);
        this.webSocketService.getMessages().subscribe(
          (message: any) => {
            const filedat = message;
            if (filedat.length > 0) {
              this.dataSource = message;
              if (this.dataSource.length > 0) {
                for (var i = 0; i < this.dataSource.length; i++) {

                  if (this.dataSource[i].fbLong) {
                    this.dataSource[i].selectfile = false;
                    const splitdat = this.dataSource[i].fbLong.split(/[:;,]+/);
                    if (splitdat[1] == 'application/pdf') {
                      this.dataSource[i].thubnail = './assets/img/icons/icon-pdf.png' + "?" + Math.floor(Math.random() * 100) + 1;
                    } else {
                      this.dataSource[i].thubnail = './assets/img/icons/icons-image.png' + "?" + Math.floor(Math.random() * 100) + 1;
                    }
                  }
                }
              }
            }
            this.webSocketService.disconnect();
          }, err => {
            this.dashboardService.openSnackBar("Please set server configuration", "OK");
          });
      } else {
        this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
      }
    } else {
      this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
    }

  }

  selectfiledata(data: any, index: any) {
    if (data.selectfile) {
      this.selectedpfile.splice(index, 1)
      this.dataSource[index].selectfile = false;
    } else {
      this.dataSource[index].selectfile = true;
      this.selectedpfile.push(data);
    }

  }
  selectallOptions(event: MatCheckboxChange, dataarray: any): void {
    if (event.checked) {
      dataarray.forEach(item => {
        this.selectedpfile.push({
          "documentName": item.documentName,
          "filePath": item.filePath,
          "documentURL": item.documentURL,
          "fbLong": item.fbLong,
          "selectfile": true
        })
      })
      this.dataSource.map(item => item.selectfile = true);

    } else {
      this.dataSource.map(item => item.selectfile = false);
      this.selectedpfile = [];
    }
  }
  openFileinBrowser(data: any) {
    if (data.fbLong) {
      const splitdat = data.fbLong.split(/[:;,]+/);
      this.imageWorkupService.openBase64InBrowser(splitdat[3], splitdat[1], data.documentName);
      this.trackingdata(data);
    }
  }
  removeprocedurefile() {
    var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
    if (mainimagepath.length > 0) {
      if (mainimagepath[0]?.propertyValue) {
        if (this.selectedpfile.length > 0) {
          var j = 0;
          for (var i = 0; i < this.selectedpfile.length; i++) {
            (async (index) => {

              const file = this.selectedpfile[index];
              await new Promise(resolve => setTimeout(resolve, 100 * index));
              const msg = {
                "message": "UPLOADFILE",
                "ACTIONTYPE": "DELETE",
                "DOCUMENTTYPE": 'PROCEDUREIMAGES',
                "DOCUMENTNAME": file.documentName,
                "BranchId": this.authservice.Loggeduser.branchid.toString(),
                "PATIENTID": this.selectedProcedure.pK_TransactionId.toString(),
                "MAINIMAGEPATH": mainimagepath[0]?.propertyValue
              }
              this.webSocketService.sendMessage(msg);
              this.webSocketService.getMessages().subscribe(
                (message: any) => {

                  j = j + 1;
                  const jsonString = JSON.stringify(message);
                  if (jsonString) {
                    if (j == this.selectedpfile.length) {

                      this.dashboardService.openSnackBar(JSON.parse(jsonString), "OK");
                      this.webSocketService.disconnect();
                      setTimeout(() => {
                        this.selectedpfile=[];
                        this.getprocedureFile();
                      }, 500);
                    }
                  }
                }, err => {
                  this.dashboardService.openSnackBar("Please set server configuration", "OK");
                });
            })(i);


          }
        } else {
          this.dashboardService.openSnackBar('Please select file', 'OK');
        }
      } else {
        this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
      }
    } else {
      this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
    }

  }
  procedureDownloadModal() {
    // const dialogRef = this.dialog.open(ProcedureDownloadComponent, {
    //   panelClass: "full-width-dialog",
    //   maxWidth: "100vw !important",
    //   height: "400px",
    //   width: "500px",
    //   disableClose: true
    // });

    // dialogRef.afterClosed().subscribe(result => {

    // });
    if (this.selectedpfile.length > 0) {
      for (var i = 0; i < this.selectedpfile.length; i++) {
        (async (index) => {
          const file = this.selectedpfile[index];
          await new Promise(resolve => setTimeout(resolve, 100 * index));
          const splitdat = file.fbLong.split(/[:;,]+/);
          this.imageWorkupService.openBase64InDownload(splitdat[3], splitdat[1], file.documentName);
        })(i);


      }
    } else {
      this.dashboardService.openSnackBar('Please select file', 'OK');
    }
  }

  
  ngOnDestroy(): void {
    this.destroyprocedure$.next(true);
    this.destroyprocedure$.unsubscribe();
    this.invdetailData = null;
    this.procedureData = null;
    this.filteredAdvisedDoctorArray = null;
    this.filteredDoctorArray = null;
    this.sourceData = null;
    this.invData = null;
    this.billdetailData = null;
    this.filteredSourceArray = null;
    this.selectedpfile = null;
    this.dataSource = null;
    this.doctorlist = null;
  }
}
